import { render, staticRenderFns } from "./netBar.vue?vue&type=template&id=4f74c672&"
import script from "./netBar.vue?vue&type=script&lang=js&"
export * from "./netBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f74c672')) {
      api.createRecord('4f74c672', component.options)
    } else {
      api.reload('4f74c672', component.options)
    }
    module.hot.accept("./netBar.vue?vue&type=template&id=4f74c672&", function () {
      api.rerender('4f74c672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manager/netBar.vue"
export default component.exports